import React, { useEffect, useState } from 'react'
import CustomInput from '../../components/CustomInput'
import CustomSelect from '../../components/CustomSelect'
import { MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import { Grid, TextField, Avatar } from '@material-ui/core'
import Loader from '../Loader'
import { Camera } from '@material-ui/icons'
// import { config } from '../../../utils/uploadImage'
import S3 from 'react-aws-s3'
import { config } from '../../utils/uploadImage'
function BusinessConfig1({ form, setForm }) {
  const { gst, numberofemployees, domain, phone, email, profilePicture, companyName, companyId, website } = form
  const [progress, setProgress] = React.useState(false)
  const [imagePreview, setImagePreview] = useState('')

  useEffect(() => {
    if (profilePicture) {
      setImagePreview(profilePicture)
    }
  }, [profilePicture])

  //console.log('PREVIEW : ', imagePreview)
  //console.log('PICTURE : ', profilePicture)

  const inputValues = [
    //    { label: '', value: profilePicture, name: 'profilePicture' },
    { label: 'Company ID', value: companyId, name: 'companyId' },
    { label: 'Company Name', value: companyName, name: 'companyName' },
    { label: 'No. of Employees', value: numberofemployees, name: 'numberofemployees' },
    { label: 'Company Email ', value: email, name: 'email' },
    { label: 'Phone Number ', value: phone, name: 'phone' },
    { label: 'Domain', value: domain, name: 'domain' },
    { label: 'GST No.', value: gst, name: 'gst' },
    { label: 'Website', value: website, name: 'website' },
    // { label: 'Company Logo', value: logo, name: 'logo', type: 'file' },
  ]
  const handleFile = (e) => {
    setProgress(true)

    if (e.target.files && e.target.files[0]) {
      let reader = new FileReader()
      reader.onload = (e) => {
        setImagePreview(e.target.result)
        // setImageUploaded(true)
      }
      reader.readAsDataURL(e.target.files[0])
      const ReactS3Client = new S3(config)
      ReactS3Client.uploadFile(e.target.files[0], `picture/${Math.random()}${e.target.files[0].name}`)
        .then((data) => {
          setForm({ ...form, profilePicture: data.location })
          //console.log(data.location)
          setProgress(false)
        })
        .catch((err) => {
          //console.log(err)
          setProgress(false)
        })
    }
  }

  return (
    <Grid container>
      <Grid item lg={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {/* <img src={profilePicture} alt="" /> */}

        {/* <Avatar src={profilePicture} style={{ width: '82px', height: 'auto' }} /> */}

        <div style={{}}>
          <input accept="image/*" style={{ display: 'none' }} id="contained-button-file" type="file" onChange={handleFile} />
          {/* {imagePreview ? (
            <Avatar src={imagePreview} style={{ width: '25%', height: '12%' }} />
          ) : (
            <Avatar style={{ width: '70px', height: '70px', marginRight: '10px' }} />
          )} */}

          <Avatar src={imagePreview} style={{ width: '82px', height: '82px' }} />
          {imagePreview ? (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
              <label htmlFor="contained-button-file">
                <Camera style={{ cursor: 'pointer' }} />
              </label>
            </div>
          ) : progress ? (
            <Loader />
          ) : (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
              <label htmlFor="contained-button-file">
                <Camera style={{ cursor: 'pointer' }} />
              </label>
            </div>
          )}
        </div>
      </Grid>
      <Grid item lg={8} container>
        {inputValues.map((item, index) => (
          <Grid item xs={12} lg={item.grid ? item.grid : 6} key={index}>
            {item.time ? (
              <div style={{ paddingTop: '20px' }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardTimePicker
                    id="time-picker"
                    style={{ width: '60%' }}
                    label="Reporting Time"
                    KeyboardButtonProps={{
                      'aria-label': 'change time',
                    }}
                  />
                </MuiPickersUtilsProvider>
              </div>
            ) : item.date ? (
              <div style={{ paddingTop: '20px' }}>
                <TextField
                  id="date"
                  label="DOB"
                  type="date"
                  defaultValue="2017-05-24"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            ) : !item.select ? (
              <CustomInput
                label={item.label}
                icon={item.icon}
                name={item.name}
                value={item.value}
                number={item.number ? true : false}
                form={form}
                setForm={setForm}
                formCheck={true}
                type={item.type}
              />
            ) : (
              <CustomSelect
                label={item.label}
                button={item.button}
                options={item.options}
                value={item.value}
                // handleChange={item.handleChange}
                form={form}
                setForm={setForm}
                formCheck={true}
                name={item.name}
                disabled={item.disabled}
                shrink={true}
              />
            )}
          </Grid>
        ))}
      </Grid>
    </Grid>
  )
}

export default BusinessConfig1
